import {createContext} from 'react'

const ListContext = createContext()

export default ListContext
